export default __webpack_public_path__ + "5f9be752e0b59f127e4c551426d54e52.png";